// Shared shell for the public legal/support pages (/privacy, /support).
// These URLs are registered in App Store Connect and must stay reachable
// without login (#336).
import { useEffect, type ReactNode } from 'react'
import { Link } from 'react-router-dom'
import './legal.css'

function LogoMark() {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" aria-hidden>
      <rect x="1" y="1" width="16" height="16" rx="4" fill="#d45a38" />
      <path d="M5 12V7.5L9 5l4 2.5V12" fill="none" stroke="#fff" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

export default function LegalPage(props: {
  eyebrow: string
  title: string
  updated?: string
  children: ReactNode
}) {
  useEffect(() => {
    document.title = `${props.title} — GroundOps`
    window.scrollTo(0, 0)
  }, [props.title])

  return (
    <div className="go-legal">
      <nav className="legal-nav">
        <Link to="/" className="legal-logo">
          <LogoMark />
          GroundOps
        </Link>
        <div className="legal-nav-links">
          <Link to="/privacy">Privacy</Link>
          <Link to="/support">Support</Link>
        </div>
      </nav>

      <main className="legal-main">
        <span className="legal-eyebrow">{props.eyebrow}</span>
        <h1>{props.title}</h1>
        {props.updated && <p className="legal-updated">Last updated: {props.updated}</p>}
        {props.children}
      </main>

      <footer className="legal-footer">
        <span>© 2026 GroundOps · All rights reserved</span>
        <span>
          <a href="mailto:support@groundops.app">support@groundops.app</a>
        </span>
      </footer>
    </div>
  )
}
